
import { defineComponent } from "vue";
import { ComponentName } from "../constants";
 
export default defineComponent({
	name: ComponentName.EbModal,
	props: {
		title: {
			type: String
		},
		visible: {
			type: Boolean
		}
	}
});
